import { onMounted, h, watch, onBeforeUnmount, computed } from "vue";
import { notification } from "ant-design-vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import GlobalMsgService, { WarnMessage } from "../message-center.service";
import msgState from "../global-msg-state";
import { useRoute } from "vue-router";
// import { useStore } from "@/store";

export default function globalMessage() {
  let timer: null | number = null;
  let notificationTimer: null | number = null;
  let messageQueue: WarnMessage[] = [];
  const route = useRoute();
  // const store = useStore();

  const isLogin = computed(() => {
    return !(
      route.path === "/login" ||
      route.path === "/join" ||
      route.path === "/setPassword" ||
      route.path === "/successPage" ||
      route.path === "/inspectionPage" ||
      route.path === "/mobileCode" ||
      route.path === "/errorPage" ||
      route.path === "/versionDetail" ||
      route.path === "/nVersionDetail" ||
      route.path === "/allVersionDetail" ||
      route.path === "/versionDetailH5" ||
      route.path === "/VideoIntroducePage" ||
      route.path === "/train/VideoIntroducePage"  ||
      route.path ===  "/maintenanceAcceptance" ||
      route.path ===  "/project/general-add"  ||
      route.path ===  "/contract/profile/ocr-create"
      
     
    );
    // return (store.state.user.userInfo as any).userId
  });

  const { data, run } = GlobalMsgService.queryGlobalMsgInfo();

  function openNotification(messageItem: WarnMessage, duration = 5): void {
    notification.open({
      message: messageItem.title,
      icon: h(ExclamationCircleOutlined, { style: { color: "red" } }),
      description: messageItem.content,
      duration,
    });
  }

  onMounted(async () => {
    isLogin.value && (await run());

    if (timer) window.clearInterval(timer);
    timer = window.setInterval(async () => {
      isLogin.value && (await run());
    }, 60000);

    if (notificationTimer) window.clearInterval(notificationTimer);
    window.setInterval(() => {
      if (!messageQueue || !messageQueue.length) return;

      const messageItem = messageQueue.shift();
      openNotification(messageItem as WarnMessage);
    }, 2000);
  });

  onBeforeUnmount(async () => {
    timer && window.clearInterval(timer);
    notificationTimer && window.clearInterval(notificationTimer);
  });

  watch(data, (newData) => {
    msgState.msgNum = newData?.num || 0;

    if (newData && newData.wornMessages && newData.wornMessages.length) {
      messageQueue = messageQueue.concat(newData.wornMessages);
    }
  });
}
